const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['checkout'] = require('../middleware/checkout.js')
middleware['checkout'] = middleware['checkout'].default || middleware['checkout']

middleware['dinein'] = require('../middleware/dinein.js')
middleware['dinein'] = middleware['dinein'].default || middleware['dinein']

middleware['routeLogger.middleware'] = require('../middleware/routeLogger.middleware.js')
middleware['routeLogger.middleware'] = middleware['routeLogger.middleware'].default || middleware['routeLogger.middleware']

middleware['userIdentifier'] = require('../middleware/userIdentifier.js')
middleware['userIdentifier'] = middleware['userIdentifier'].default || middleware['userIdentifier']

export default middleware
